import React, { useEffect, useState } from 'react';
import MetaModelLogo from '../../Images/sidebar/Logo_MetaModel.svg';
import './style.scss';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
// import { projects } from '../../../../../shared-lib/src/config';

const baseUrl = 'https://api-nimbus.flixstock.com/';
const distributorId = '663b39b3ab4ec46c6ebcf259';




const PlanDetails = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null); // useState to store token

 

  useEffect(() => {
    const localToken = localStorage.getItem('metamodel_token');
    setToken(localToken); 
  }, []); 

  const getPayment = async () => {
    const priceInfoId = searchParams.get('piid');
    const rateCode = searchParams.get('rcid');
    const redirectby = searchParams.get('redirectby');

    

    if (!token) {
      message.error('Authentication token is missing');
      return;
    }
    
    const postBody = {
      priceInfoId,
      rateCode,
      host: `${window.location.protocol}//${window.location.host}`,
      txnMetadata: redirectby
        ? JSON.stringify({ priceInfoId, rateCode, redirectby })
        : {},
      mode: window.location.host === 'localhost:3002' ? 'test' : 'live',
    };

    try {
      setLoading(true);
      const response = await axios.post(
        `${baseUrl}api/v1/pricing/checkout`,
        postBody,
        {
          headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            distributorId,
          },
        }
      );
      const result = response.data;
      if (result?.url) {
        window.open(result.url, '_top');
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="my_plan_details">
      <div className="plan_section">
        {/* <img src={MetaModelLogo} alt="MetaModel Logo" className="logo" /> */}
        <div className="plan_heading">
          <h2 className="plan_title">
            {console.log('Plan',searchParams.get('plan'))}
            {searchParams.get('plan') === 'Business'
              ? 'Business Plan'
              : searchParams.get('plan')}
          </h2>
          <Link to="/subscription" className="change_link">
            Change
          </Link>
        </div>
        <div className="credit_details">
          <p className="credit_desc">
            {searchParams.get('credits')} credits
          </p>
          <p className="credit_desc">
            {searchParams.get('currency')}
            {searchParams.get('rate')}
          </p>
        </div>
        <div className="total_pricing">
          <h2 className="total_title">Total</h2>
          <h2 className="total_price">
            {searchParams.get('currency')}
            {searchParams.get('rate')}
          </h2>
        </div>
        <button className="button_two" onClick={getPayment} disabled={loading}>
          Make Payment
          {loading && (
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 24,
                    color: 'white',
                    marginLeft: 20,
                  }}
                  spin
                />
              }
            />
          )}
        </button>
        <Link to="/subscription" className="cancel_link">
          Cancel
        </Link>
      </div>
    </div>
  );
};

export default PlanDetails;
